import React from 'react';
import { Year } from '../atoms/Year';
import { useCalendar } from '../hooks/useCalendar';

interface YearGridProps {
  currentDate: Date;
  selectedYear?: number;
  onYearSelect: (year: number) => void;
  yearRange?: number;
  className?: string;
}

export const YearGrid: React.FC<YearGridProps> = ({
  currentDate,
  selectedYear,
  onYearSelect,
  yearRange = 12,
  className = '',
}) => {
  const { getYearRange } = useCalendar(
    currentDate,
    () => {},
    () => {}
  );

  const years = getYearRange(currentDate.getFullYear(), yearRange);

  return (
    <div className={`ui-mx-auto ui-grid ui-w-fit ui-grid-cols-3 ${className}`}>
      {years.map((year) => (
        <Year
          key={year}
          year={year}
          isSelected={selectedYear === year}
          isDisabled={false}
          onClick={onYearSelect}
        />
      ))}
    </div>
  );
};
